// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1mkzZ","name":"ConsentHeader_name__UT3JL","birthday":"ConsentHeader_birthday__GmAQO","skeleton":"ConsentHeader_skeleton__A3n6A"};